import { postLogout } from '@/api/auth';
import TimeText from './time-text';
import {auth, logoutFirebase} from '@/config/firebase';
import {useAppDispatch} from '@/hooks/redux';
import {setSector, setSelectedRadar} from '@/redux/slice/emissionSlice';
import {Popover} from 'antd';
import classNames from 'classnames';
import {useMemo} from 'react';
import {useAuthState} from 'react-firebase-hooks/auth';
import {useLocation, useNavigate} from 'react-router-dom';

const SidebarPopoverContent = () => {
  const navigate = useNavigate();
  const onLogout = async () => {
      await postLogout();
      localStorage.clear();
      await logoutFirebase();

    setTimeout(() => {
      navigate('/login');
    }, 500);
  };
  return (
    <div className="bg-black/50 py-[8px] px-[16px]">
      <div
        onClick={onLogout}
        className="block text-white text-md cursor-pointer py-[8px]"
      >
        Logout
      </div>
    </div>
  );
};

const ATCHeader = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [user] = useAuthState(auth);
  const nameText = useMemo(() => {
    const name = user?.displayName;
    if (!name) return 'MA';
    // First character of first name and last name
    return name
      ?.split(' ')
      .map((n) => n[0])
      .join('');
  }, [user]);

  const activeTab = useLocation().pathname;

  const changeToPerformance = () => {
    dispatch(setSelectedRadar(null));
    window.updateData({
      event: 'camera',
      data: {
        center: [103.806241, 1.3246091],
        zoom: 5
      }
    });
    navigate('/atc/performance');
  };

  const changeToLiveEmission = () => {
    dispatch(setSector(null));
    window.updateData({
      event: 'camera',
      data: {
        center: [103.806241, 1.3246091],
        zoom: 5
      }
    });
    navigate('/atc');
  };

  return (
    <div className="bg-transparent h-[60px] px-[24px] flex items-center justify-between">
      <div className="flex items-center">
        <div
          className="hover:opacity-80 cursor-pointer flex-none"
          onClick={() => navigate('/atc')}
        >
          <svg
            width="122"
            height="24"
            viewBox="0 0 122 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_11187_602669)">
              <path
                d="M0.196503 0.0251546C0.318147 -0.0246832 0.455387 0.000235677 0.54584 0.0936815L12.0147 11.547L23.4836 0.0936815C23.5741 0.00335054 23.7144 -0.0246832 23.8329 0.0251546C23.9515 0.0749923 24.0295 0.190242 24.0295 0.321066V11.9987C24.0295 12.0828 23.9951 12.1638 23.9359 12.2261C23.9359 12.2261 23.9296 12.2323 23.9265 12.2354L18.1843 17.9667V23.6794C18.1843 23.8102 18.1063 23.9255 17.9847 23.9753C17.8661 24.0252 17.7258 23.9971 17.6353 23.9068L12.0147 18.2938L6.39413 23.9068C6.33175 23.9691 6.25065 24.0002 6.16644 24.0002C6.12589 24.0002 6.08222 23.9909 6.04479 23.9753C5.92627 23.9255 5.84829 23.8102 5.84829 23.6794V17.973L0.0935726 12.2261C0.03431 12.1669 0 12.0859 0 11.9987V0.321066C0 0.190242 0.0779772 0.0749923 0.196503 0.0251546Z"
                fill="#D9F99D"
              />
              <path
                d="M32.8307 7.62793H34.462L37.8369 16.3776H36.1931L35.3728 14.0632H31.8763L31.056 16.3776H29.4746L32.837 7.62793H32.8307ZM32.2911 12.8952H34.9673L33.6542 9.13241H33.6168L32.2911 12.8952Z"
                fill="#D9F99D"
              />
              <path
                d="M44.5859 10.4097C44.5204 10.1574 44.43 9.92378 44.3146 9.71197C44.2023 9.50016 44.0526 9.31638 43.8717 9.16064C43.6908 9.0049 43.4818 8.88653 43.2385 8.79932C42.9952 8.7121 42.7176 8.67161 42.3963 8.67161C41.9285 8.67161 41.5261 8.76505 41.1893 8.95194C40.8493 9.14195 40.5748 9.39114 40.3627 9.70574C40.1506 10.0203 39.9915 10.3786 39.8917 10.7773C39.7888 11.1791 39.7389 11.5871 39.7389 12.0014C39.7389 12.4157 39.7888 12.8268 39.8917 13.2255C39.9946 13.6242 40.1506 13.9824 40.3627 14.297C40.5748 14.6116 40.8524 14.8639 41.1893 15.0508C41.5261 15.2377 41.9316 15.3343 42.3963 15.3343C42.7394 15.3343 43.042 15.2751 43.304 15.1567C43.566 15.0384 43.7906 14.8764 43.9777 14.6677C44.1649 14.459 44.3115 14.2161 44.4206 13.9388C44.5267 13.6616 44.5953 13.3626 44.6296 13.0449H46.1268C46.0925 13.5682 45.9802 14.0447 45.7899 14.4777C45.5965 14.9107 45.3376 15.2845 45.0101 15.5991C44.6826 15.9137 44.299 16.1566 43.8561 16.3279C43.4132 16.4993 42.9266 16.5865 42.3963 16.5865C41.7413 16.5865 41.1549 16.465 40.6372 16.2251C40.1194 15.9853 39.6796 15.6551 39.3178 15.2377C38.9591 14.8203 38.6815 14.3344 38.4912 13.78C38.2979 13.2255 38.2012 12.6337 38.2012 12.0014C38.2012 11.3691 38.2979 10.7928 38.4912 10.2384C38.6815 9.68394 38.9591 9.1949 39.3178 8.78063C39.6796 8.36324 40.1163 8.03306 40.6372 7.78699C41.1581 7.54091 41.7445 7.41943 42.3963 7.41943C42.8892 7.41943 43.3508 7.48796 43.7843 7.6219C44.2179 7.75584 44.6015 7.95208 44.9322 8.21061C45.2628 8.46914 45.531 8.78063 45.7369 9.14818C45.9396 9.51573 46.0675 9.93624 46.1174 10.4097H44.5828H44.5859Z"
                fill="#D9F99D"
              />
              <path
                d="M48.6111 10.4097C48.6766 10.1574 48.7671 9.92378 48.8825 9.71197C48.9948 9.50016 49.1445 9.31638 49.3254 9.16064C49.5063 9.0049 49.7153 8.88653 49.9586 8.79932C50.2019 8.7121 50.4795 8.67161 50.8007 8.67161C51.2686 8.67161 51.671 8.76505 52.0078 8.95194C52.3478 9.14195 52.6223 9.39114 52.8344 9.70574C53.0465 10.0203 53.2056 10.3786 53.3054 10.7773C53.4083 11.1791 53.4582 11.5871 53.4582 12.0014C53.4582 12.4157 53.4083 12.8268 53.3054 13.2255C53.2024 13.6242 53.0465 13.9824 52.8344 14.297C52.6223 14.6116 52.3447 14.8639 52.0078 15.0508C51.671 15.2377 51.2655 15.3343 50.8007 15.3343C50.4576 15.3343 50.1551 15.2751 49.8931 15.1567C49.6311 15.0384 49.4065 14.8764 49.2194 14.6677C49.0322 14.459 48.8856 14.2161 48.7765 13.9388C48.6704 13.6616 48.6018 13.3626 48.5675 13.0449H47.0703C47.1046 13.5682 47.2169 14.0447 47.4072 14.4777C47.6006 14.9107 47.8594 15.2845 48.1869 15.5991C48.5145 15.9137 48.8981 16.1566 49.341 16.3279C49.7839 16.4993 50.2705 16.5865 50.8007 16.5865C51.4557 16.5865 52.0421 16.465 52.5599 16.2251C53.0777 15.9853 53.5175 15.6551 53.8793 15.2377C54.238 14.8203 54.5156 14.3344 54.7058 13.78C54.8992 13.2255 54.9959 12.6337 54.9959 12.0014C54.9959 11.3691 54.8992 10.7928 54.7058 10.2384C54.5156 9.68394 54.238 9.1949 53.8793 8.78063C53.5175 8.36324 53.0808 8.03306 52.5599 7.78699C52.039 7.54091 51.4526 7.41943 50.8007 7.41943C50.3079 7.41943 49.8463 7.48796 49.4127 7.6219C48.9792 7.75584 48.5955 7.95208 48.2649 8.21061C47.9343 8.46914 47.6661 8.78063 47.4602 9.14818C47.2575 9.51573 47.1296 9.93624 47.0797 10.4097H48.6143H48.6111Z"
                fill="#D9F99D"
              />
              <path
                d="M56.293 7.62793H57.8276V12.727C57.8276 13.0198 57.84 13.3188 57.8712 13.6209C57.8993 13.9231 57.9804 14.1941 58.1145 14.437C58.2518 14.6769 58.4545 14.8762 58.729 15.032C59.0035 15.1877 59.3902 15.2656 59.8893 15.2656C60.3883 15.2656 60.7751 15.1877 61.0496 15.032C61.3241 14.8762 61.5268 14.68 61.664 14.437C61.7982 14.1972 61.8793 13.9231 61.9073 13.6209C61.9354 13.3188 61.951 13.0198 61.951 12.727V7.62793H63.4856V13.2284C63.4856 13.7922 63.3983 14.2813 63.2267 14.6987C63.0552 15.1161 62.8119 15.4649 62.4968 15.7453C62.1818 16.0287 61.8044 16.2374 61.3615 16.3776C60.9186 16.5177 60.4289 16.5863 59.8893 16.5863C59.3497 16.5863 58.86 16.5177 58.4171 16.3776C57.9742 16.2374 57.5967 16.0287 57.2817 15.7453C56.9667 15.4649 56.7234 15.1129 56.5519 14.6987C56.3803 14.2813 56.293 13.7922 56.293 13.2284V7.62793Z"
                fill="#D9F99D"
              />
              <path
                d="M65.2227 7.62793H67.3811L69.7984 14.4775H69.8233L72.1813 7.62793H74.3148V16.3776H72.8551V9.62456H72.8301L70.4003 16.3776H69.1371L66.7073 9.62456H66.6824V16.3776H65.2227V7.62793Z"
                fill="#D9F99D"
              />
              <path
                d="M76.0586 7.62793H77.5932V12.727C77.5932 13.0198 77.6057 13.3188 77.6369 13.6209C77.6649 13.9231 77.746 14.1941 77.8801 14.437C78.0174 14.6769 78.2201 14.8762 78.4946 15.032C78.7691 15.1877 79.1558 15.2656 79.6549 15.2656C80.154 15.2656 80.5407 15.1877 80.8152 15.032C81.0897 14.8762 81.2924 14.68 81.4297 14.437C81.5638 14.1972 81.6449 13.9231 81.673 13.6209C81.701 13.3188 81.7166 13.0198 81.7166 12.727V7.62793H83.2512V13.2284C83.2512 13.7922 83.1639 14.2813 82.9923 14.6987C82.8208 15.1161 82.5775 15.4649 82.2625 15.7453C81.9474 16.0287 81.57 16.2374 81.1271 16.3776C80.6842 16.5177 80.1945 16.5863 79.6549 16.5863C79.1153 16.5863 78.6256 16.5177 78.1827 16.3776C77.7398 16.2374 77.3624 16.0287 77.0473 15.7453C76.7323 15.4649 76.489 15.1129 76.3175 14.6987C76.1459 14.2813 76.0586 13.7922 76.0586 13.2284V7.62793Z"
                fill="#D9F99D"
              />
              <path
                d="M85.0156 7.62793H86.5502V15.0538H91.0043V16.3776H85.0156V7.62793Z"
                fill="#D9F99D"
              />
              <path
                d="M91.9629 7.62793H93.4975V12.727C93.4975 13.0198 93.51 13.3188 93.5411 13.6209C93.5692 13.9231 93.6503 14.1941 93.7844 14.437C93.9217 14.6769 94.1244 14.8762 94.3989 15.032C94.6734 15.1877 95.0601 15.2656 95.5592 15.2656C96.0583 15.2656 96.445 15.1877 96.7195 15.032C96.994 14.8762 97.1967 14.68 97.334 14.437C97.4681 14.1972 97.5492 13.9231 97.5772 13.6209C97.6053 13.3188 97.6209 13.0198 97.6209 12.727V7.62793H99.1555V13.2284C99.1555 13.7922 99.0682 14.2813 98.8966 14.6987C98.7251 15.1161 98.4818 15.4649 98.1668 15.7453C97.8517 16.0287 97.4743 16.2374 97.0314 16.3776C96.5885 16.5177 96.0988 16.5863 95.5592 16.5863C95.0196 16.5863 94.5299 16.5177 94.087 16.3776C93.6441 16.2374 93.2667 16.0287 92.9516 15.7453C92.6366 15.4649 92.3933 15.1129 92.2218 14.6987C92.0502 14.2813 91.9629 13.7922 91.9629 13.2284V7.62793Z"
                fill="#D9F99D"
              />
              <path
                d="M101.924 13.4593C101.924 13.7957 101.981 14.0791 102.096 14.319C102.208 14.5557 102.37 14.7488 102.573 14.9014C102.776 15.0541 103.013 15.1631 103.278 15.2316C103.543 15.3001 103.833 15.3375 104.145 15.3375C104.479 15.3375 104.766 15.3001 105.003 15.2223C105.24 15.1444 105.433 15.0447 105.58 14.9233C105.727 14.8018 105.833 14.6585 105.898 14.4996C105.964 14.3408 105.995 14.1788 105.995 14.0137C105.995 13.6804 105.92 13.4312 105.767 13.2724C105.614 13.1135 105.449 13.0014 105.271 12.936C104.959 12.8207 104.597 12.7148 104.186 12.612C103.771 12.5092 103.263 12.3784 102.657 12.2133C102.28 12.1168 101.968 11.9859 101.719 11.8271C101.469 11.6682 101.269 11.4907 101.123 11.2944C100.976 11.0982 100.87 10.8895 100.808 10.6715C100.745 10.4503 100.717 10.226 100.717 9.99866C100.717 9.55635 100.808 9.17633 100.995 8.85239C101.179 8.53156 101.422 8.26056 101.725 8.04875C102.027 7.83694 102.37 7.6812 102.754 7.57841C103.138 7.47562 103.528 7.42578 103.921 7.42578C104.379 7.42578 104.81 7.48496 105.215 7.60333C105.621 7.72169 105.976 7.89924 106.282 8.13597C106.587 8.3727 106.831 8.6655 107.012 9.01125C107.193 9.35699 107.28 9.75881 107.28 10.2167H105.745C105.705 9.65291 105.511 9.2542 105.168 9.02059C104.825 8.78697 104.385 8.67173 103.855 8.67173C103.674 8.67173 103.49 8.69041 103.303 8.72779C103.116 8.76517 102.941 8.82435 102.788 8.91157C102.632 8.99879 102.505 9.11404 102.402 9.26043C102.299 9.40683 102.249 9.59061 102.249 9.81176C102.249 10.1233 102.346 10.3662 102.539 10.5406C102.729 10.7151 102.982 10.849 103.294 10.9393C103.325 10.9487 103.456 10.983 103.68 11.0452C103.905 11.1075 104.158 11.173 104.435 11.2477C104.713 11.3225 104.984 11.3941 105.252 11.4626C105.518 11.5312 105.708 11.5841 105.823 11.6153C106.11 11.7056 106.36 11.8271 106.572 11.9828C106.784 12.1386 106.962 12.3161 107.105 12.5155C107.249 12.7148 107.355 12.9297 107.423 13.1571C107.492 13.3876 107.526 13.615 107.526 13.8424C107.526 14.3345 107.426 14.7519 107.227 15.0977C107.027 15.4434 106.762 15.73 106.435 15.948C106.107 16.1692 105.736 16.3312 105.318 16.4308C104.9 16.5336 104.476 16.5835 104.042 16.5835C103.543 16.5835 103.072 16.5212 102.632 16.3997C102.19 16.2782 101.806 16.0882 101.478 15.8359C101.151 15.5836 100.889 15.2597 100.692 14.861C100.496 14.4654 100.393 13.9981 100.387 13.4593H101.921H101.924Z"
                fill="#D9F99D"
              />
              <path
                d="M114.626 7.62793H116.257L119.632 16.3776H117.988L117.168 14.0632H113.671L112.851 16.3776H111.27L114.632 7.62793H114.626ZM114.083 12.8952H116.759L115.446 9.13241H115.409L114.083 12.8952Z"
                fill="#D9F99D"
              />
              <path
                d="M120.465 7.62793H121.999V16.3776H120.465V7.62793Z"
                fill="#D9F99D"
              />
            </g>
            <defs>
              <clipPath id="clip0_11187_602669">
                <rect width="122" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div className="ml-[16px] flex items-center">
          <div
            onClick={changeToLiveEmission}
            className={classNames(
              'cursor-pointer h-[44px] flex-1 flex items-center justify-center rounded-[6px] px-[16px]',
              {
                'bg-[#38BDF81A]': activeTab === '/atc'
              }
            )}
          >
            <p
              className={classNames(
                'text-[#A8A29E] font-Geist text-[14px] font-[500] leading-[20px] tracking-[-0.28px]',
                {
                  '!text-[#38BDF8]': activeTab === '/atc'
                }
              )}
            >
              Live Emissions
            </p>
          </div>
          <div
            onClick={changeToPerformance}
            className={classNames(
              'cursor-pointer h-[44px] flex-1 flex items-center justify-center rounded-[6px] px-[16px]',
              {
                'bg-[#38BDF81A]': activeTab === '/atc/performance'
              }
            )}
          >
            <p
              className={classNames(
                'text-[#A8A29E] font-Geist text-[14px] font-[500] leading-[20px] tracking-[-0.28px] whitespace-nowrap',
                {
                  '!text-[#38BDF8]': activeTab === '/atc/performance'
                }
              )}
            >
              Emissions Performance
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center">
        <TimeText />

        {user && (
          <Popover
            content={<SidebarPopoverContent />}
            placement="bottom"
            overlayClassName="sidebar-popover"
            trigger="click"
          >
            <div
              className={classNames(
                'w-[40px] h-[40px] rounded-full bg-[#272727] text-[#94969C] text-xs',
                'flex items-center justify-center cursor-pointer'
              )}
            >
              <span>{nameText}</span>
            </div>
          </Popover>
        )}
      </div>
    </div>
  );
};

export default ATCHeader;
